<template>
  <pcg-box>
    <div class="pcg-box-inner-header">
      <i class="pcg-icon-bookmark oneline"></i>
      <span class="oneline">{{ $t('components.abk_managing_offers.title') }}</span>
      <div class="d-none d-sm-inline-block">
        <pcg-sort-btn class="add-button" :options="sortOptions" :value="order" @input="changeOrder"/>
      </div>
      <router-link v-if="offers && totalOffers > offers.length"
                   class="ml-auto pcg-link pcg-small"
                   :to="{ name: 'offers_list_path' }">
        {{ $t('general.show_more') }}
      </router-link>
    </div>
    <template v-if="offers && offers.length">
      <div class="all-records-text">{{ $t('components.abk_managing_offers.offers_count') }}: {{ totalOffers }}</div>
      <abk-list :items="offers" :items-column-name="$t('general.offer')">
        <template v-slot="item">
          <div class="ml-auto d-flex">
            <div class="p-2 offer-time d-none d-lg-block d-xl-block" v-if="item.expirationDate || item.publicationDate">
            <span class="text-nowrap">
              <i class="far fa-clock fa-lg offer-icon"></i>
              {{ getDuration(item) }}
            </span>
            </div>
            <div class="p-2 offer-count ml-2 ml-sm-4">
              <span v-if="item.offerApplicationsCount >= 50"><i class="fas fa-fire fire-icon"></i></span>
              {{ $tc('components.abk_managing_offers.applications', item.offerApplicationsCount) }}
            </div>
          </div>
        </template>
      </abk-list>
    </template>
    <span v-else class="pcg-no-records">{{ $t('components.abk_managing_offers.no_records') }}</span>
  </pcg-box>
</template>

<script>
import AbkList from './AbkList'

export default {
  name: 'abk-managing-offers',
  components: { AbkList },
  props: {
    offers: Array,
    totalOffers: Number,
    order: Object
  },
  data: function () {
    return {
      sortOptions: [
        { text: this.$t('general.date_of_publication'), value: 'publication_date' },
        { text: this.$t('general.time_to_end'), value: 'expiration_date' }
      ]
    }
  },
  methods: {
    changeOrder (newOrder) {
      this.$emit('changeOrder', newOrder)
    },
    getDuration ({ publicationDate, expirationDate }) {
      const start = this.formatDate(publicationDate, 'DD.MM.YYYY')
      const end = this.formatDate(expirationDate, 'DD.MM.YYYY')

      if (start && end) {
        return _.uniq([start, end]).join(' - ')
      } else if (start) {
        return `${this.$t('general.from')} ${start}`
      }
      return `${this.$t('general.to')} ${end}`
    },
    formatDate (date, format) {
      const newDate = moment(date)
      return newDate.isValid() ? newDate.format(format) : null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/stylesheets/vars';

  .all-records-text {
    font-weight: 500;
    color: $pcg-gray;
    font-size: $font-size-s;
    margin-bottom: $pcg-m-xs;
  }

  .add-button {
    margin-left: 2rem;
  }

  .oneline {
    display: inline-block;
  }

  .offer-id {
    line-height: 2.2;
    margin: 4px 0;
    font-size: $font-size-s;
    width: 40px;
    background-color: $pcg-the-lightest-gray;
    color: $pcg-dark-gray;
    text-align: center;
    border-radius: 5px;
  }

  .offer-type {
    font-size: $font-size-xs;
    font-weight: 400;
    color: $pcg-dark-gray;
  }

  .offer-title {
    font-weight: 500;
    text-transform: uppercase;
    color: $main-color;
  }

  .offer-count {
    line-height: 2.2;
    margin: 4px 0;
    font-size: $font-size-s;
    min-width: 7.2rem;
    max-width: 7.2rem;
    background-color: $pcg-the-lightest-gray;
    color: $main-active-color;
    text-align: center;
    border-radius: 5px;
  }

  .offer {
    list-style: none;
    padding: .2em 0;
    &:not(:last-child) {
      border-bottom: 1px solid $pcg-lightest-gray;
    }
    &.no-border {
      border: none;
    }
  }

  .offer-time {
    align-self: flex-end;
    font-size: $font-size-s;
    font-weight: 400;
    color: $pcg-dark-gray;
  }

  .offer-icon {
    margin-right: .2rem;
  }

  .fire-icon {
    color: $pcg-red;
    margin-right: .2rem;
  }
  .p-2 {
    padding: 0.2rem !important;
  }
</style>

<style scoped lang="scss">
  @import "../assets/stylesheets/vars-contrast";
  .contrast{
    .offer-id {
      background-color: $pcg-the-lightest-gray;
      color: $pcg-dark-gray;
    }

    .offer-type {
      color: $pcg-dark-gray;
    }

    .offer-title {
      color: $main-color;
    }

    .offer-count {
      background-color: $pcg-the-lightest-gray;
      color: $main-active-color;
    }

    .offer {
      &:not(:last-child) {
        border-bottom: 1px solid $pcg-lightest-gray;
      }
    }

    .offer-time {
      color: $pcg-dark-gray;
    }

    .fire-icon {
      color: $pcg-red;
    }

    .add-button {
      color: $pcg-gray;
      /deep/ .bootstrap-select .dropdown-toggle {
        color: $main-color !important;
        border: none;
      }
    }
  }
</style>
